<script setup lang="ts">
const ServicesMobilityContent = defineAsyncComponent(() => import('~/components/molecules/ServicesMobilityContent.vue'));
definePageMeta({
  layout: "services-layout",
});
</script>

<template>
  <ServicesMobilityContent />
</template>
